import { Link, useLocation } from 'react-router-dom';
import { clsx } from 'clsx';
import type { ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode;
}

const navigation = [
  { name: 'Dashboard', href: '/', icon: '📊' },
  { name: 'Updates', href: '/updates', icon: '📝' },
  { name: 'Users', href: '/users', icon: '👥' },
  { name: 'Hashtags', href: '/hashtags', icon: '#️⃣' },
  { name: 'Settings', href: '/settings', icon: '⚙️' },
];

export default function Layout({ children }: LayoutProps) {
  const location = useLocation();

  return (
    <div className="min-h-screen flex">
      {/* Sidebar */}
      <aside className="w-64 bg-gray-900 text-white">
        <div className="p-6">
          <h1 className="text-2xl font-bold flex items-center gap-2">
            <span>⚡</span>
            <span>Power Move</span>
          </h1>
          <p className="text-gray-400 text-sm mt-1">Powering Executional Intelligence</p>
        </div>

        <nav className="mt-6">
          {navigation.map((item) => {
            const isActive = location.pathname === item.href;
            return (
              <Link
                key={item.name}
                to={item.href}
                className={clsx(
                  'flex items-center gap-3 px-6 py-3 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-primary-600 text-white'
                    : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                )}
              >
                <span>{item.icon}</span>
                <span>{item.name}</span>
              </Link>
            );
          })}
        </nav>

        <div className="absolute bottom-0 left-0 w-64 p-4 border-t border-gray-800">
          <div className="text-xs text-gray-500">
            <p>Slack Bot Status: <span className="text-green-400">Connected</span></p>
          </div>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 p-8 overflow-auto">
        {children}
      </main>
    </div>
  );
}
